// extracted by mini-css-extract-plugin
export var aTagButton = "EmailForm-module--aTagButton--3fad8";
export var cardBlueTitle = "EmailForm-module--cardBlueTitle--c14e7";
export var cardCents = "EmailForm-module--cardCents--a3989";
export var cardTitle = "EmailForm-module--cardTitle--09d83";
export var mailInputContainer = "EmailForm-module--mailInputContainer--e2d0b";
export var signupButton = "EmailForm-module--signupButton--7a8c8";